module.exports = __webpack_public_path__ + "files/be1467c94744c27c6bfb4bbe6f200471.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/custom-1.png
// module id = 1489
// module chunks = 60